import { useState, useEffect } from "react";
import { Box, Typography, IconButton, useMediaQuery, Button  } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const HeadlineDisplay = ({ headlines, setSearchQuery }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [startIndex, setStartIndex] = useState(0);
  const maxVisible = 1; // Show one headline at a time on mobile
  const [isExpanded, setIsExpanded] = useState(false);

  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % headlines.length);
  };

  const handlePrev = () => {
    setStartIndex((prev) => (prev - 1 + headlines.length) % headlines.length);
  };

  // Auto-scroll every 4 seconds
  useEffect(() => {
    const interval = setInterval(handleNext, 6000);
    return () => clearInterval(interval);
  }, [startIndex]);

  return (
    <Box sx={{ textAlign: "center", p: 1, maxWidth: "100%", marginBottom: '10px', marginTop: '10px' }}>
  <Typography color="primary" sx={{ fontSize: "1rem", mb: 1, color: '#0066FF' }}>
    Try Fact-Checking These Trending Headlines
  </Typography>

  {isMobile ? (
    // Mobile: Auto-scrolling one headline at a time
    <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
    <IconButton onClick={handlePrev}>
      <ArrowBackIosNewIcon />
    </IconButton>

    <Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    scrollBehavior: 'smooth',
    width: '80%',
    justifyContent: 'center',
    textAlign: 'center',
  }}
>
  <Typography
    onClick={() => setSearchQuery(headlines[startIndex])}
    sx={{
      cursor: 'pointer',
      textDecoration: 'underline',
      fontSize: '0.85rem',
      maxWidth: '100%',
      p: 1,
      wordBreak: 'break-word',
    }}
  >
    {isExpanded
      ? headlines[startIndex]
      : headlines[startIndex].length > 40
      ? (
          <>
            {headlines[startIndex].slice(0, 40)}...
            <Button
              onClick={(e) => {
                e.stopPropagation(); // prevent triggering Typography's click
                setIsExpanded(true);
              }}
              size="small"
              sx={{
                fontSize: '0.8rem',
                textTransform: 'none',
                color: '#0066FF',
                ml: 1,
                p: 0,
                minWidth: 'auto',
              }}
            >
              Expand Headline
            </Button>
          </>
        )
      : headlines[startIndex]}
  </Typography>

  {isExpanded && headlines[startIndex].length > 40 && (
    <Button
      onClick={() => setIsExpanded(false)}
      size="small"
      sx={{ fontSize: '0.8rem', textTransform: 'none', color: '#0066FF' }}
    >
      Show Less
    </Button>
  )}
</Box>



    <IconButton onClick={handleNext}>
      <ArrowForwardIosIcon />
    </IconButton>
  </Box>
  ) : (
    // Desktop: Regular vertical list
    <Box
      sx={{
        textAlign: "left",
        pl: 2,
        maxHeight: 100, // Adjust height as needed
        overflowY: "auto", // Enables vertical scrolling
      }}
    >
      <ul style={{ paddingLeft: "20px", listStyleType: "disc" }}>
        {headlines.map((article, index) => (
          <li key={index}>
            <Typography
              onClick={() => setSearchQuery(article)} // Access the title property
              sx={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "primary.main",
                fontSize: "1rem",
                mb: 1,
                wordBreak: "break-word", // Ensures long text wraps properly
              }}
            >
              {article} {/* Access the title property */}
            </Typography>
          </li>
        ))}
      </ul>
    </Box>
  )}
</Box>

  );
};

export default HeadlineDisplay;
